
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/cloud-dashboard-management",
      function () {
        return require("private-next-pages/features/cloud-dashboard-management.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/cloud-dashboard-management"])
      });
    }
  